export default "Calculez votre trajectoire OPERAT obligatoire (−40 % 2030, −50 % 2040, −60 % 2050) et obtenez un plan d'actions pour vos bâtiments tertiaires ≥ 1 000 m².";
